/** @format */

import axios from "axios";
import { Config } from "config";

export const updateUserDetails = (token, userDetails) => {
    return axios.put(`${Config.MyDNV.azureFnPath}/updateUserDetails`, userDetails, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
};

export const updateAddressDetails = (token, addressDetails) => {
    return axios.put(`${Config.MyDNV.azureFnPath}/updateAddressDetails`, addressDetails, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
};

export const getUserAddress = (args) => {
    return axios.get(`${Config.MyDNV.azureFnPath}/getUserAddress`, {
        validateStatus: function (status) {
            return (status >= 200 && status < 300) || status === 403 || status === 401; // default + 403 + 401
        },
        headers: {
            Authorization: `Bearer ${args}`,
            "Content-Type": "application/json",
        },
    });
};

export const deleteUserAccount = (token) => {
    return axios.post(
        `${Config.MyDNV.azureFnPath}/deleteUserAccount`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
};
